import { RestMethodsEnum } from '../@types/api';
import { callAdminApi } from '../services/api';

export const getBrandsListApi = (search: string) =>
  callAdminApi(RestMethodsEnum.GET, `/brand/${search || ''}`);

export const getSuppliersListApi = (search: string) =>
  callAdminApi(RestMethodsEnum.GET, `/supplier/${search || ''}`);
